import { useSelector } from "react-redux"

export const useHelpDeskSelector = () => {
    return useSelector((state) => state.helpDesk)
}

